import api from './api';

export const adminService = {
  // Dashboard stats
  getStats: async () => {
    const response = await api.get('/admin/stats/');
    return response.data;
  },

  getAnalytics: async () => {
    const response = await api.get('/admin/analytics/');
    return response.data;
  },

  getBookingsAnalytics: async () => {
    const response = await api.get('/admin/bookings-analytics/');
    return response.data;
  },

  // User management
  getUsers: async (params = {}) => {
    const response = await api.get('/admin/users/', { params });
    return response.data;
  },

  getUserDetails: async (userId) => {
    const response = await api.get(`/admin/users/${userId}/`);
    return response.data;
  },

  updateUser: async (userId, data) => {
    const response = await api.patch(`/admin/users/${userId}/`, data);
    return response.data;
  },

  activateUser: async (userId) => {
    const response = await api.post(`/admin/users/${userId}/activate/`);
    return response.data;
  },

  deactivateUser: async (userId) => {
    const response = await api.post(`/admin/users/${userId}/deactivate/`);
    return response.data;
  },

  updateUserStatus: async (userId, status) => {
    const response = await api.post(`/admin/users/${userId}/update-status/`, { status });
    return response.data;
  },

  // Password management
  sendPasswordToUser: async (userId) => {
    const response = await api.post(`/admin/users/${userId}/send-password/`);
    return response.data;
  },

  getUserPassword: async (userId) => {
    const response = await api.get(`/admin/users/${userId}/get-password/`);
    return response.data;
  },

  resetUserPassword: async (userId, data = {}) => {
    const response = await api.post(`/admin/users/${userId}/reset-password/`, data);
    return response.data;
  },

  // Free trial management
  extendFreeTrial: async (userId) => {
    const response = await api.post(`/admin/users/${userId}/extend-free-trial/`);
    return response.data;
  },

  // Billing reports
  getBillingReports: async (params = {}) => {
    const response = await api.get('/admin/billing-reports/', { params });
    return response.data;
  },

  // Authentication
  login: async (credentials) => {
    const response = await api.post('/admin/auth/login/', credentials);
    if (response.data.access) {
      localStorage.setItem('admin_token', response.data.access);
      localStorage.setItem('admin_refresh', response.data.refresh);
    }
    return response.data;
  },

  logout: async () => {
    try {
      const refreshToken = localStorage.getItem('admin_refresh');
      if (refreshToken) {
        await api.post('/admin/auth/logout/', { refresh: refreshToken });
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_refresh');
    }
  },

  getCurrentUser: async () => {
    const response = await api.get('/admin/auth/user/');
    return response.data;
  },

  // Specializations CRUD
  getSpecializations: async (params = {}) => {
    const response = await api.get('/admin/specializations/', { params });
    return response.data;
  },

  createSpecialization: async (data) => {
    const response = await api.post('/admin/specializations/', data);
    return response.data;
  },

  updateSpecialization: async (id, data) => {
    const response = await api.put(`/admin/specializations/${id}/`, data);
    return response.data;
  },

  deleteSpecialization: async (id) => {
    const response = await api.delete(`/admin/specializations/${id}/`);
    return response.data;
  },

  // Class Types CRUD
  getClassTypes: async (params = {}) => {
    const response = await api.get('/admin/class-types/', { params });
    return response.data;
  },

  createClassType: async (data) => {
    const response = await api.post('/admin/class-types/', data);
    return response.data;
  },

  updateClassType: async (id, data) => {
    const response = await api.put(`/admin/class-types/${id}/`, data);
    return response.data;
  },

  deleteClassType: async (id) => {
    const response = await api.delete(`/admin/class-types/${id}/`);
    return response.data;
  },
};

export default adminService;
